<template>
  <div class="go-in">
    <div
      class="organizational"
      :style="`height:${pageLoading ? '3rem' : 'auto'};`"
      v-loading="pageLoading"
    >
      <div style="box-sizing: border-box">
        <TitleTips
          :routerList="routerList"
          routeType="/news/publicAnnouncement"
          title="公示公告"
        />
      </div>
      <div
        style="
          display: flex;
          justify-content: flex-start;
          flex-direction: column;
          font-size: 16px;
        "
      >
        <div
          v-for="(item, index) in pageDataList"
          :key="index"
          style="
            display: flex;
            flex-wrap: wrap;
            justify-content: space-around;
            margin-bottom: 0.1rem;
            width: 100%;
          "
        >
          <!-- 从此处开始遍历新闻 -->
          <!-- <div style="margin-bottom: 0.35rem; display: flex" v-if="index == 0">
            <div>
              <img
                style="width: 2.45rem; margin-right: 0.5rem"
                :src="getEditorImg(item.txt)[0]"
                alt=""
              />
            </div>
            <div>
              <div class="news-content" @click="clickNewsItem(item,index)">
                <p>{{ item.title }}</p>
                <p>{{ item.createTime }}</p>
                <p>{{ getPlainTex(item.txt) }}</p>
              </div>
            </div>
          </div> -->
          <div class="news-list" @click="clickNewsItem(item, index)">
            <div>
              <i class="el-icon-document" style="color: #bfbfbf"></i>
              <span
                style="color: #333333; margin-left: 0.03rem; font-size: 0.15rem"
                >{{ item.title }}</span
              >
            </div>
            <span style="font-size: 0.12rem; margin-right: 0.4rem; color: #ccc">
              {{ item.createTime }}
            </span>
          </div>
        </div>
        <div
          style="margin: 0.2rem 0rem; font-size: 0.16rem; align-self: center"
        >
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pageNum"
            :page-sizes="[10, 20, 30, 40, 50]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
          >
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TitleTips from '../components/TitleTips.vue';
import ComponentProduct from '../components/ComponentProduct.vue';
import http from '../utils/http';
export default {
  components: {
    TitleTips,
    ComponentProduct
  },
  name: 'companyNews',
  data() {
    return {
      pageLoading: false,
      pageNum: 1,
      pageSize: 10,
      total: 0,
      formData: {
        groupType: '104'
      },
      pageDataList: [],
      routerList: []
    };
  },
  created() {
    this.getData();
  },
  methods: {
    getData() {
      this.pageLoading = false;
      http
        .post('/reception/news/getNewsPage', {
          ...this.formData,
          pageSize: this.pageSize,
          pageNum: this.pageNum,
          title: ''
        })
        .then(res => {
          this.pageDataList = res.rows;
          this.total = res.total;
        })
        .finally(() => {
          this.pageLoading = false;
        });
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getData();
    },
    handleCurrentChange(val) {
      this.pageNum = val;
      this.getData();
    },
    getEditorImg(str) {
      var data = [];
      str.replace(
        /<img [^>]*src=['"]([^'"]+)[^>]*>/,
        function (match, capture) {
          data.push(capture);
        }
      );
      console.log(data);
      return data;
    },
    convertIdeogramToNormalCharacter(val) {
      const arrEntities = { lt: '<', gt: '>', nbsp: ' ', amp: '&', quot: '"' };
      return val.replace(/&(lt|gt|nbsp|amp|quot);/gi, function (all, t) {
        return arrEntities[t];
      });
    },
    getPlainTex(richCont) {
      const str = richCont;
      let value = richCont;
      if (richCont) {
        // 方法一：
        value = value.replace(/\s*/g, ''); //去掉空格
        value = value.replace(/<[^>]+>/g, ''); //去掉所有的html标记
        value = value.replace(/↵/g, ''); //去掉所有的↵符号
        value = value.replace(/[\r\n]/g, ''); //去掉回车换行
        value = value.replace(/&nbsp;/g, ''); //去掉空格
        value = this.convertIdeogramToNormalCharacter(value);
        return value;
      } else {
        return null;
      }
    },
    clickNewsItem(item, index = 0) {
      // let params = {
      //   pageNum: this.pageNum,
      //   pageSize: this.pageSize,
      //   currntIndex: index,
      //   currentPageDataList: this.pageDataList,
      //   groupType:'102'
      // };
      this.$router.push({ path: `/news/newsDetail/${item.id}` });
    }
  },
  mounted() {
    this.routerList = this.$route.matched;
  },

  watch: {}
};
</script>

<style lang="scss" scoped>
* {
  margin: 0;
  padding: 0;
}

.go-in {
  .organizational {
    width: 100%;
    box-sizing: border-box;
    padding: 0rem 1rem 0rem 1rem;
    .news-content {
      box-sizing: border-box;
      cursor: pointer;
      padding: 0.1rem;
      background: #f2f2f26f;
      width: 8.88rem;
      height: 100%;
      p:nth-child(1) {
        color: #333;
        font-size: 0.18rem;
        font-weight: 600;
      }
      p:nth-child(2) {
        margin: 0.05rem 0rem;
        color: #333;
        font-size: 0.14rem;
      }
      p:nth-child(3) {
        margin: 0.05rem 0rem;
        font-size: 0.13rem;
        text-overflow: -o-ellipsis-lastline;
        overflow: hidden; //溢出内容隐藏
        text-overflow: ellipsis; //文本溢出部分用省略号表示
        display: -webkit-box; //特别显示模式

        -webkit-box-orient: vertical; //盒子中内容竖直排列
      }
    }
    .news-list {
      width: 100%;
      height: 0.49rem;
      display: flex;
      justify-content: space-between;
      align-items: center;
      cursor: pointer;
      border-bottom: 1px solid #bfbfbf;
    }
  }
}
</style>
